import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { useFocus } from '@core/js/hooks/useFocus';
import { useTranslations } from '@core/js/hooks/i18n';
import { Icon } from '@core/js/components/common/Icon';
import { useNavigate } from '@theme/js/hooks/navigate';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useDeviceSelector, useMyAccountSidebarSelector } from '@core/js/store/hooks';
import { Link } from '@theme/js/components/common/Link';

import * as hooks from '@core/js/components/main/MyAccountSidebar/hooks';
import * as actions from '@core/js/components/main/MyAccountSidebar/store/actions';

import style from './Header.scss';

/* Lugano changes */
export const Logo = () => {
    const { customization: { siteLogoPath = '' } = {}, requestStamp, themeName } = useAppSelector(pick([
        'customization', 'requestStamp', 'themeName'
    ]));
    const navigate = useNavigate();
    const closeSidebar = hooks.useHandleSidebarClose();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const casinoname = searchParams.get('casinoname');
    const site = searchParams.get('site');
    const params = new URLSearchParams({
        t: siteLogoPath ? requestStamp : Date.now(),
        ...casinoname && { casinoname },
        ...site && { site }
    });
    const logoURL = siteLogoPath
        ? `${siteLogoPath}?${params.toString()}`
        : `/${themeName}/images/logo.png?${params.toString()}`;
    const onClick = useCallback(() => {
        navigate('/');
        closeSidebar();
    }, [closeSidebar, navigate]);

    return (
        <div className={style.logo}>
            <Link href="/" onClick={onClick}>
                <img className={style.logoImage} src={logoURL} alt="logo" />
            </Link>
        </div>
    );
};
/* Lugano changes */

export const Header = () => {
    const dispatch = useDispatch();
    const translate = useTranslations();
    const [focusRef, setFocus] = useFocus();
    const handleSidebarClose = hooks.useHandleSidebarClose();
    const {
        isOpened,
        portalPageURL,
        isBackArrowHidden,
        sidebarMenu: { isSubMenuShown }
    } = useMyAccountSidebarSelector(pick(['isOpened', 'portalPageURL', 'isBackArrowHidden', 'sidebarMenu']));
    const { isMobile } = useDeviceSelector(pick(['isMobile'])); /* Lugano changes */

    const handleBackArrowClick = useCallback(() => {
        portalPageURL ? dispatch(actions.showHomePage()) : dispatch(actions.showMainMenu());
    }, [dispatch, portalPageURL]);

    useEffect(() => {
        if (isOpened) {
            setTimeout(() => {
                setFocus();
            }, 0);
        }
    }, [isOpened, setFocus]);

    return (
        <div className={`${style.header} cms-my-account-sidebar-header`}>
            <span ref={focusRef} tabIndex={-1} aria-hidden={true} />
            {(portalPageURL && !isBackArrowHidden || !portalPageURL && isSubMenuShown) && (
                <div className={style.backIconContainer}>
                    <Icon
                        role="button"
                        type={'back_arrow'}
                        className={style.backIcon}
                        onClick={handleBackArrowClick}
                        aria-label={translate('playtech.mobile.system.myAccountSidebar.header.aria.backArrow')}
                    />
                </div>
            )}
            {/* Lugano changes */}
            {isMobile && <Logo/>}
            <div className={style.closeIconContainer}
                 onClick={handleSidebarClose} >
                <span className={style.iconClose}></span>
            </div>
            {/* Lugano changes */}
        </div>
    );
};
